<script lang="ts" setup>
import { computed, type TransitionGroupProps, type VNode } from 'vue';
import useTransitionBase from '../VTransitionBase/composables/transitionBase';
import type { Props } from '../VTransitionBase/types';
import { propsDefaults } from '../VTransitionBase/utils';

const props = withDefaults(
  defineProps<
    Props & {
      tag?: TransitionGroupProps['tag'];
    }
  >(),
  propsDefaults,
);

const { classAttributes, needsContainers } = useTransitionBase(() => props);

// Zie https://vuejs-language-tools.vercel.app/features/slots#how-to-handle-indeterminate-slot-types
const slots = defineSlots();

const slotChildren = computed(() => {
  if (!slots.default) return [];

  const defaultSlots = slots.default();
  if (!Array.isArray(defaultSlots) || defaultSlots.length === 0) return [];

  return defaultSlots.map(({ children }) => children).flat() as VNode[];
});
</script>

<template>
  <TransitionGroup v-if="needsContainers" v-bind="classAttributes" :tag="props.tag">
    <div v-for="component in slotChildren" :key="component.key ?? undefined">
      <div>
        <Component :is="component" />
      </div>
    </div>
  </TransitionGroup>

  <TransitionGroup v-else v-bind="classAttributes" :tag="props.tag">
    <slot></slot>
  </TransitionGroup>
</template>
